import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Dialog, DialogTitle, DialogContent, Typography, Divider
} from '@mui/material';
import { getDefaultRowColor } from './utils/dynamicTableUtils';
import React, { useState, useEffect } from 'react';

const ClickableTableWithPopup = ({dataObject, onRowClick}) => {
  const [tableSize, setTableSize] = useState('small');
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  
  useEffect(() => {
    if (dataObject && dataObject.size) {
      setTableSize('small');
    }
  }, [dataObject]);


  if (!dataObject || !dataObject.data || !Array.isArray(dataObject.data) || dataObject.data.length === 0) {
    return <p>Currently, no information is available. <b/> Please choose a different value.</p>
  }

  const fieldNames = dataObject.data.length > 0 ? Object.keys(dataObject.data[0]) : [];

  function formatFieldName(fieldName) {
    return fieldName
        .toLowerCase()
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

  const handleRowClick = async (row) => {
    if (onRowClick) {
      const result = await onRowClick(row);
      setSelectedRow(result);
    } else {
      setSelectedRow(row);
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  return (
    <>
    <TableContainer component={Paper} sx={{ height: '100%' }}>
      <Table sx={{ minWidth: 650, backgroundColor: '#2C3E50' }} size={tableSize} aria-label="clickable table">
        <TableHead>
          <TableRow>
            {fieldNames.map((fieldName) => (
              <TableCell align="center" key={fieldName} sx={{ backgroundColor: '#2C3E50', color: 'white' }}>
                <strong>{formatFieldName(fieldName)}</strong>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {dataObject.data.map((dataItem, index) => (
            <TableRow
              key={index}
              hover
              onClick={() => handleRowClick(dataItem)}
              sx={{
                cursor: 'pointer',
                '&:last-child td, &:last-child th': { border: 0 },
                backgroundColor: getDefaultRowColor(index),
              }}
            >
              {fieldNames.map((fieldName) => (
                <TableCell align="center" key={fieldName}>
                  {dataItem[fieldName]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

    <Dialog open={open} onClose={handleClose} scroll="paper" maxWidth="lg" fullWidth>
      <DialogTitle>Row Details</DialogTitle>
      <DialogContent dividers>
        {Array.isArray(selectedRow) && selectedRow.length > 0 ? (
          <Table size="small">
            <TableHead>
              <TableRow>
                {Object.keys(selectedRow[0]).map((key) => (
                  <TableCell key={key}><strong>{formatFieldName(key)}</strong></TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedRow.map((row, idx) => (
                <TableRow key={idx}>
                  {Object.values(row).map((value, i) => (
                    <TableCell key={i}>
                      {typeof value === 'object'
                        ? <pre style={{ margin: 0 }}>{JSON.stringify(value, null, 2)}</pre>
                        : String(value)}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography>No data available.</Typography>
        )}
      </DialogContent>
    </Dialog>
    </>
  );
}

export default ClickableTableWithPopup